import styled from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";

export const _LandingHighlightTwoProductsRoot = styled.div`
  width: 100%;
  padding: 0 24px;
  background-color: #7dabd0;

  @media (${responsiveMap.mobile}) {
    padding: 0 28px;
  }
`;

export const _LandingHighlightTwoProductsHeader = styled.div`
  text-align: center;
  max-width: 776px;
  margin-inline: auto;
  margin-bottom: 63px;

  @media (${responsiveMap.mobile}) {
    margin-bottom: 57px;
  }
`;

export const _LandingHighlightTwoProductsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
